import { useQuery } from "@tanstack/react-query";
import { getTasksDashboard } from "@/modules/tasks/api";
import { BasePaginationTasksResponse, TasksResponse } from "@/modules/tasks/dtos";
import { useLeadContext } from "@/modules/lead-page/context/lead-page.context";
import { useMemo } from "react";
import { TaskStatusesBackend } from "@/modules/tasks/enums";

export const useGetLeadTasks = () => {
  const { lead } = useLeadContext();

  const leadId = useMemo(() => {
    return lead?.data?.nanoId;
  }, [lead]);

  const filters = useMemo(() => {
    if (!leadId) return {};
    
    return {
      linkedEntitiesUIds: leadId
    };
  }, [leadId]);

  const {
    data: tasksData,
    isLoading,
    isError,
    refetch,
  } = useQuery<BasePaginationTasksResponse<TasksResponse>>({
    queryKey: ["lead-tasks", leadId],
    queryFn: async () => {
      const response = await getTasksDashboard({
        filters: {
          ...filters,
          status: TaskStatusesBackend.pending,
        },
        pagination: {
          page: 1,
          pageSize: 7,
        },
      });
      return response.data;
    },
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    enabled: !!leadId,
    staleTime: 0, // Always consider data stale so it refetches on window focus
  });

  return {
    leadTasks: tasksData?.data || [],
    isLoading,
    isError,
    refetch,
  };
};




